import {
    isErrorCollection,
    isLoadedCollection,
    isLoadingCollection,
} from './collectionGuard';
import { AnyCollection, CollectionStatus } from './collectionModel';

export function combineCollectionStatus(
    ...collection: AnyCollection<any>[]
): CollectionStatus {
    if (collection.some((item) => isLoadingCollection(item))) {
        return 'loading';
    }
    if (collection.some((item) => isErrorCollection(item))) {
        return 'error';
    }
    return 'loaded';
}
